export default __webpack_public_path__ + "static/media/bannerBg.56ccc1f0.png";